'use strict';

const makeAbortable = ({ promise, onAborted, onFulfilled, onRejected }) => {
    let isAborted = false;
    const abort = () => {
        isAborted = true;
        onAborted?.(promise);
    };
    promise
        .then(value => (isAborted ? undefined : onFulfilled?.(value)))
        .catch(error => (isAborted ? undefined : onRejected?.(error)));
    return { abort };
};

exports.makeAbortable = makeAbortable;
//# sourceMappingURL=promise.js.map
